import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// ORGANIZAR ESSA BAGUNÇA, APENAS UMA FUNÇÃO DE FORMAT DATE DEVE EXISTIR E RECEBER PARAMETROS PARA SER FLEXÍVEL

const formataDate = (date, mask) => {
  if (!date) return '-';
  if (!mask) mask = 'MMM yyyy'
  const [ano, mes, dia] = date.split('-');
  return format(new Date(Number(ano), Number(mes - 1), Number(dia)), mask, { locale: ptBR }).toUpperCase()
};

const formataDateNum = (date, mask) => {
  if (!date) return '-';
  if (!mask) mask = 'dd/MM/yyyy'
  const [ano, mes, dia] = date.split('-');
  return format(new Date(Number(dia), Number(mes - 1), Number(ano)), mask, { locale: ptBR })
};

const formataDatetime = (datetime, mask) => {
  if (!mask) mask = 'dd/MM/yyyy HH:mm:ss'
  return format(new Date(datetime), mask, { locale: ptBR })
};

const getUltimoDiaDoMes = () => {
  const agora = new Date();
  return format(new Date(agora.getFullYear(), agora.getMonth() + 1, 0), 'dd/MM/yyyy', { locale: ptBR })
};

const meses = [
    'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
    'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
];

function formatarMesReferencia(
  lista,
  campo = 'mesReferencia'
) {
  return lista.map(item => {
    const [ano, mes] = item[campo].split('-');

    return {
      ...item,
      [campo]: `${meses[Number(mes) - 1]}-${ano}`
    };
  });
}

function formatarMesReferenciaPorChave(
  lista,
  chaveListaInterna,
  campo = 'mesReferencia'
) {
  return lista.map(item => ({
    ...item,
    [chaveListaInterna]: formatarMesReferencia(
      item[chaveListaInterna],
      campo
    )
  }));
}

export {
  formataDate,
  formataDatetime,
  formataDateNum,
  getUltimoDiaDoMes,
  formatarMesReferencia,
  formatarMesReferenciaPorChave
}